import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import AboutsPage from 'containers/pages/abouts/List'
import AboutsForm from 'containers/pages/abouts/Form'

const Abouts = ({
  currentUser, location, match,
}) => {
  if (location.pathname === '/about') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-csotentang-dplk-read') > -1) {
      return <AboutsPage location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('edit') || location.pathname.includes('add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-csotentang-dplk-write') > -1) {
      return <AboutsForm location={location} match={match} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('detail')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-pelajari-manfaat-read') > -1) {
      return <BenefitsDetail location={location} match={match} />
    }
    return <ForbiddenPage />
  }

  return ''
}

Abouts.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default Abouts
